<template>
    <div class="example-full">
        <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
            <h3>{{$t('Drop files to upload')}}</h3>
        </div>
        <div class="upload">
            <div class="table-responsive">
               <v-list  v-if="files.length>0" two-line>
                   <template v-for="(file, index) in files" >
                       <v-list-tile

                               :key="file.id"
                               avatar
                               @click=""
                       >
                           <v-list-tile-avatar>
                               <FileIcon :mimetype="file.type" round></FileIcon>
                           </v-list-tile-avatar>

                           <v-list-tile-content>
                               <v-list-tile-title v-html="file.name"></v-list-tile-title>
                               <v-list-tile-sub-title v-html="$prettyBytes(file.size)"></v-list-tile-sub-title>
                           </v-list-tile-content>

                           <v-list-tile-action>
                               <v-btn icon ripple @click.prevent="$refs.upload.remove(file)">
                                   <v-icon color="grey lighten-1">close</v-icon>
                               </v-btn>
                           </v-list-tile-action>
                       </v-list-tile>
                   </template>
               </v-list>
            </div>

              <!--  <div class="footer-status float-right">
                    Drop: {{$refs.upload ? $refs.upload.drop : false}},
                    Active: {{$refs.upload ? $refs.upload.active : false}},
                    Uploaded: {{$refs.upload ? $refs.upload.uploaded : true}},
                    Drop active: {{$refs.upload ? $refs.upload.dropActive : false}}
                </div> -->
                <strong>{{$t('or drop a file here')}}</strong>
                <div class="btn-group" v-if="$user">
                    <file-upload
                            class="btn btn-primary dropdown-toggle"
                            :post-action="postAction"
                            :put-action="putAction"
                            :extensions="extensions"
                            :accept="accept"
                            :multiple="multiple"
                            :directory="directory"
                            :size="size || 0"
                            :thread="thread < 1 ? 1 : (thread > 5 ? 5 : thread)"
                            :headers="headers"
                            :data="data"
                            :drop="drop"
                            :drop-directory="dropDirectory"
                            :add-index="addIndex"
                            v-model="files"
                            @input-filter="inputFilter"
                            @input-file="inputFile"
                            ref="upload">
                        <v-chip round color="primary" class="white--text">{{$t('Upload a file')}}
                        </v-chip>
                        <!--<vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"></vue-dropzone>-->
                    </file-upload>
                </div>
        </div>

    </div>
</template>
<style>

    .example-full .btn-group .dropdown-menu {
        display: block;
        visibility: hidden;
        transition: all .2s
    }
    .example-full .btn-group:hover > .dropdown-menu {
        visibility: visible;
    }
    .example-full label.dropdown-item {
        margin-bottom: 0;
    }
    .example-full .btn-group .dropdown-toggle {
        margin-right: .6rem
    }
    .example-full .filename {
        margin-bottom: .3rem
    }
    .example-full .btn-is-option {
        margin-top: 0.25rem;
    }
    .example-full .example-foorer {
        padding: .5rem 0;
        border-top: 1px solid #e9ecef;
        border-bottom: 1px solid #e9ecef;
    }
    .example-full .edit-image img {
        max-width: 100%;
    }
    .example-full .edit-image-tool {
        margin-top: .6rem;
    }
    .example-full .edit-image-tool .btn-group{
        margin-right: .6rem;
    }
    .example-full .footer-status {
        padding-top: .4rem;
    }
    .example-full .drop-active {
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        position: fixed;
        z-index: 9999;
        opacity: .6;
        text-align: center;
        background: #000;
    }
    .example-full .drop-active h3 {
        margin: -.5em 0 0;
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
        font-size: 40px;
        color: #fff;
        padding: 0;
    }
    @import url("https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css");
</style>

<script>
    import FileUpload from 'vue-upload-component'
    import {VList,VListTile,VListTileAvatar,VListTileTitle,VListTileSubTitle,VListTileContent,VListTileAction,VIcon,VImg,VBtn,VFlex,VChip} from 'vuetify/lib'
    import FileIcon from "../FileIcon";
    import config from "../../config";
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'

    export default {
        components: {
            FileIcon,
            FileUpload,VList,VListTile,VListTileAvatar,VListTileTitle,VListTileContent,VListTileSubTitle,VListTileAction,VIcon,VImg,VBtn,VFlex,VChip,
            vueDropzone: vue2Dropzone
        },
        props: ['value'],
        data() {
            return {
                files: this.value,
                accept: 'application/pdf, image/tiff, image/jpeg, image/png, .step, .stp, .igs, .iges, .obj, .3dm, .3mf, .doc, .docx, .odt, .ods, .xlsx, .xls, .odp, .pptx, .ppt, .txt, .rtf, .odg',
                extensions: 'pdf,tiff,tif,step,igs,obj,3dm,3mf',
                // extensions: ['gif', 'jpg', 'jpeg','png', 'webp'],
                // extensions: /\.(gif|jpe?g|png|webp)$/i,
                minSize: 1024,
                size: 1024 * 1024 * 10,
                multiple: true,
                directory: false,
                drop: true,
                dropDirectory: true,
                addIndex: false,
                thread: 3,
                name: 'file',
                postAction: '/upload/post',
                putAction: '/upload/put',
                headers: {
                    'X-Csrf-Token': 'xxxx',
                },
                data: {
                    '_csrf_token': 'xxxxxx',
                },
                autoCompress: 1024 * 1024,

                uploadAuto: false,
                ipfs:config.ipfs,
                dropzoneOptions: {
                    url: 'localhost',
                    thumbnailWidth: 150,
                    dictDefaultMessage: "<i class='fa fa-cloud-upload'></i>UPLOAD ME"
                }
            }
        },
        methods: {
            inputFilter(newFile, oldFile, prevent) {
                if (newFile && !oldFile) {
                    // Before adding a file
                    // Filter system files or hide files

                    if (!config.acceptEverything) {
                        if (!(/\.(pdf?|jpg?|tif?|tiff?|png?|igs?|iges?|stp?|step?|obj?|3dm?|3mf?)$/i.test(newFile.name.toLowerCase()))) {
                            this.$root.$emit('show-snackbar', {
                                message: this.$t('Image format not accepted:') + newFile.name,
                                color: 'error',
                                timeout: 6000
                            });
                            return prevent()
                        }

                        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
                            return prevent()
                        }
                        // Filter php html js file

                        if ((/\.(php5?|html?|jsx?)$/i.test(newFile.name))) {
                            return prevent()
                        }
                    }

                }
                if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
                    // Create a blob field

                    newFile.blob = ''
                    let URL = window.URL || window.webkitURL
                    if (URL && URL.createObjectURL) {
                        newFile.blob = URL.createObjectURL(newFile.file)
                    }
                    // Thumbnails

                    newFile.thumb = ''
                    if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
                        newFile.thumb = newFile.blob
                    }
                }
            },
            // add, update, remove File Event
            inputFile(newFile, oldFile) {
                if (newFile && oldFile) {
                    // update
                    if (newFile.active && !oldFile.active) {
                        // beforeSend
                        // min size
                        if (newFile.size >= 0 && this.minSize > 0 && newFile.size < this.minSize) {
                            this.$refs.upload.update(newFile, { error: 'size' })
                        }
                    }
                    if (newFile.progress !== oldFile.progress) {
                        // progress
                    }
                    if (newFile.error && !oldFile.error) {
                        // error
                    }
                    if (newFile.success && !oldFile.success) {
                        // success
                    }
                }
                if (!newFile && oldFile) {
                    // remove
                    if (oldFile.success && oldFile.response.id) {
                        // $.ajax({
                        //   type: 'DELETE',
                        //   url: '/upload/delete?id=' + oldFile.response.id,
                        // })
                    }
                }
                // Automatically activate upload
                if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
                    if (this.uploadAuto && !this.$refs.upload.active) {
                        this.$refs.upload.active = true
                    }
                }
                this.update();
            },
            update:function(){
                this.$emit('input',this.files)
            },
            alert(message) {
                alert(message)
            },
            // add folader
            onAddFolader() {
                if (!this.$refs.upload.features.directory) {
                    this.alert('Your browser does not support')
                    return
                }
                let input = this.$refs.upload.$el.querySelector('input')
                input.directory = true
                input.webkitdirectory = true
                this.directory = true
                input.onclick = null
                input.click()
                input.onclick = (e) => {
                    this.directory = false
                    input.directory = false
                    input.webkitdirectory = false
                }
            },
        }
    }
</script>
